import { Link } from "react-router-dom";
import { 
  Briefcase, Scale, Palette, GraduationCap, Zap, Coffee, ArrowRight 
} from "lucide-react";

const categories = [
  { icon: Zap, label: "Productivity", tools: ["Grammar Assistant", "Language Translator", "Calculator"] },
  { icon: Briefcase, label: "Business", tools: ["Invoice Generator", "SEO Analyzer", "Chatbot Builder"] },
  { icon: Scale, label: "Legal & Security", tools: ["Contract Analyzer", "Cyber Security", "Password Generator"] },
  { icon: Palette, label: "Creative", tools: ["AI Image Generator", "Blog Assistant", "PDF StoryBook"] },
  { icon: GraduationCap, label: "Learning", tools: ["Math Professor", "College Ready", "Prompt Studio"] },
  { icon: Coffee, label: "Everyday AI", tools: ["Personal Chef", "TravelGPT", "Relationship Coach"] },
];

export const CategoryShowcase = () => (
  <section id="features" className="py-20 px-4">
    <div className="max-w-6xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-3">Tools for Every Need</h2>
      <p className="text-muted-foreground text-center mb-12 max-w-xl mx-auto">
        Curated AI capabilities organized by what you actually need to get done.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {categories.map((cat) => {
          const Icon = cat.icon;
          return (
            <Link
              key={cat.label}
              to="/tools"
              className="group p-6 rounded-2xl border border-border bg-card hover:border-primary/30 hover:shadow-lg transition-all duration-300 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none"
              aria-label={`Explore ${cat.label} tools: ${cat.tools.join(", ")}`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center">
                  <Icon className="h-5 w-5 text-primary" />
                </div>
                <h3 className="font-semibold text-lg">{cat.label}</h3>
              </div>
              <div className="space-y-2 mb-4">
                {cat.tools.map((tool) => (
                  <div key={tool} className="text-sm text-muted-foreground flex items-center gap-2">
                    <span className="h-1 w-1 rounded-full bg-primary/60 shrink-0" />
                    {tool}
                  </div>
                ))}
              </div>
              <span className="text-sm text-primary font-medium flex items-center gap-1 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">
                Explore <ArrowRight className="h-3.5 w-3.5" />
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);
